import { ADD_BOOKING } from "../booking/actionTypes";

const formatDate = (dateString)=>{
  const date = new Date(dateString);
  const yyyy = date.getFullYear();
  let mm = date.getMonth() + 1; // Months start at 0!
  let dd = date.getDate();

  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = '0' + mm;

  return dd + '-' + mm + '-' + yyyy;
}


// just to practice the middleware 
const bookingMiddleware = (store)=>(next)=>(action)=>{

  if(action.type === ADD_BOOKING){
    const state = store.getState();
    if(state?.bookings?.length >=3) {
      alert('Maximum of three bookings per user allowed. Please adjust your booking accordingly. Thank you.')
      return;
    };

    action = {
      ...action,
      payload: {
        ...action.payload,
        date : formatDate(action?.payload?.date),
        id : Math.floor(Math.random() * 90000000) + 10000000
      }
    }
  }

  return next(action);
}

export default bookingMiddleware;
